<template>
    <div>
        <activity-select class="mt-4" :disableComponent="show_all_activities"/>
        <v-divider></v-divider>
        <v-container>
            <v-row v-for="(person, pI) in persons"
                   :key="pI"
                   class="mb-4"
            >
                <v-col cols="12">
                    <v-card class="pa-3"
                            elevation="10"
                            color="grey lighten-2"
                    >

                        <v-card-title class="headline" v-if="person.firstName">
                            {{ person.firstName }} {{ person.lastName }}
                            <v-spacer></v-spacer>
                            <v-btn
                                    icon
                                    @click="person.tickets.splice(pI, 1)"
                            >
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-card-title>

                        <v-card-title class="headline" v-else>
                            {{ $tc('Person', 1) }}
                            <v-spacer></v-spacer>
                            <v-btn
                                    icon
                                    @click="persons.splice(pI, 1)"
                            >
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-card-title>

                        <v-card class="pa-3 mb-3">
                            <v-row>
                                <v-col cols="2"
                                       md="1"
                                >
                                    <v-text-field
                                            v-model="person.phoneNumberPrefix"
                                            placeholder="+46"
                                            :label="$t('Prefix')"
                                            :rules="[rules.required]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="10"
                                       md="2"
                                >
                                    <v-text-field
                                            v-model="person.phoneNumber"
                                            placeholder="701234567"
                                            :label="$t('MobilePhoneNumber')"
                                            :rules="[rules.required]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12"
                                       md="4"
                                       sm="5"
                                >
                                    <v-text-field
                                            v-model="person.firstName"
                                            :placeholder="$t('FirstName')"
                                            :label="$t('FirstName')"
                                            :rules="[rules.required]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12"
                                       md="5"
                                       sm="7"
                                >
                                    <v-text-field
                                            v-model="person.lastName"
                                            :placeholder="$t('LastName')"
                                            :label="$t('LastName')"
                                            :rules="[rules.required]"
                                    ></v-text-field>
                                </v-col>

                            </v-row>

                            <v-row>

                                <v-col cols="6">
                                    <v-text-field
                                            v-model="person.email"
                                            :placeholder="$t('Email')"
                                            :label="$t('Email')"
                                            :rules="[rules.required, rules.email]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field
                                            v-model="person.birthDate"
                                            placeholder="19850819"
                                            :label="$t('BirthDate')"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field
                                            v-model="person.lastFour"
                                            placeholder="0000"
                                            :label="$t('LastFour')"
                                    ></v-text-field>
                                </v-col>

                            </v-row>

                        </v-card>

                        <v-card class="pa-3 lig"
                                elevation="2"
                        >
                            <v-card-title class="headline">
                                {{ $tc('Ticket', 3) }}
                            </v-card-title>

                            <v-container>
                                <v-row>
                                    <v-card
                                            v-for="(ticket, i) in person.tickets"
                                            :key="i"
                                            class="mr-2 mb-2"
                                    >

                                        <v-card-title>
                                            {{ ticket.header }}
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                    icon
                                                    @click="person.tickets.splice(i, 1)"
                                            >
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                        </v-card-title>

                                        <v-card-text>
                                            {{ ticket.content }}
                                        </v-card-text>

                                    </v-card>

                                    <v-btn color="primary"
                                           @click="ticketDialogIsOpen = true"
                                    >
                                        <v-icon>add</v-icon>
                                        {{ $t('AddTicket') }}
                                    </v-btn>

                                </v-row>
                            </v-container>

                        </v-card>

                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <v-btn color="primary mt-3"
                           @click="addPerson()"
                    >
                        <v-icon>add</v-icon>{{ $t('AddPerson') }}
                    </v-btn>
                </v-col>
                <v-btn
                        v-show="true"
                        color="green"
                        dark
                        bottom
                        block
                        x-large
                >
                    <v-icon>done</v-icon>
                    {{ $t('Register') }}
                </v-btn>
            </v-row>
        </v-container>

        <v-dialog
                v-model="ticketDialogIsOpen"
                :fullscreen="$vuetify.breakpoint.smAndDown"
                scrollable
        >
            <v-card>
                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-card flat
                                    class="mb-3 pa-3"
                            >
                                <v-card-title class="justify-center">1. {{ $t('SelectValidFrom') }}</v-card-title>

                                <v-date-picker v-model="fromDatePicker"
                                               full-width
                                               :landscape="$vuetify.breakpoint.smAndUp"
                                               :first-day-of-week="firstDayOfWeek"
                                               :locale="$i18n.locale"
                                >
                                </v-date-picker>
                            </v-card>
                        </v-col>
                    </v-row>

                <v-divider></v-divider>

                    <v-row>
                        <v-col cols="12">

                            <v-card flat>
                                <v-card-title class="justify-center">2. {{ $t('SelectTicketType') }}</v-card-title>

                                <v-item-group v-model="selectedTicketTypeIndex">
                                        <v-row>
                                            <v-col v-for="(ticketType, tTI) in ticketTypes"
                                                   :key="tTI"
                                                   cols="12"
                                                   md="4"
                                            >
                                                <v-item v-slot="{ active, toggle }">
                                                    <v-card
                                                            :color="active ? 'accent' : ''"
                                                            class="ml-3 mb-3"
                                                            @click="toggle"
                                                    >
                                                        <v-card-title>
                                                            {{ ticketType.short_description_phrase }}
                                                        </v-card-title>
                                                        <v-card-text>
                                                            {{ ticketType.long_description_phrase }}<br>
                                                            {{ ticketType.price }} SEK
                                                        </v-card-text>
                                                    </v-card>
                                                </v-item>
                                            </v-col>
                                        </v-row>
                                </v-item-group>

                            </v-card>

                        </v-col>
                    </v-row>

                </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn
                            color="red"
                            dark
                            large
                            @click="closeTicketDialogWithoutAction()"
                    >
                        {{ $t('Cancel') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="green"
                            dark
                            large
                            :disabled="selectedTicketTypeIndex == null"
                            @click="addTicketAndCloseDialog()"
                    >
                        <v-icon>add</v-icon>
                        {{ $t('Add') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script lang="ts">
    import i18n from "../i18n";
    import Ticket from "../core/models/Ticket.js";
    import Person from "../core/models/Person.js";
    import TicketType from "../core/models/TicketType";
    import ActivitySelect from "../components/ActivitySelect.vue";
    import {mapGetters} from "vuex";

    export default {
        name: "BuyView",
        components: {
            ActivitySelect,
        },
        methods: {
            addTicketAndCloseDialog() {
                let selectedTicketType = this.ticketTypes[this.selectedTicketTypeIndex]
                this.persons[0].tickets.push(new Ticket(selectedTicketType.short_description_phrase
                    , i18n.t('ValidFrom') + ' ' + this.fromDatePicker
                    )
                );
                this.selectedTicketTypeIndex = null;
                this.ticketDialogIsOpen = false;
            },
            closeTicketDialogWithoutAction() {
                this.selectedTicketTypeIndex = null;
                this.ticketDialogIsOpen = false;
            },
            addPerson() {
                this.persons.push(new Person());
            }
        },
        data: () => ({
            rules: {
                required: value => !!value || i18n.t('Required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || i18n.t('InvalidEmail')
                }
            },
            ticketDialogIsOpen: false,
            fromDatePicker: new Date().toISOString().substr(0, 10),
            persons: [
                new Person('',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    [],
                ),
            ],
            ticketTypes: [
                new TicketType('1-dagskort',
                    'Giltigt 1 dag',
                    '100 kr',
                    '2020-12-01',
                    '2021-04-01',
                ),
                new TicketType('2-dagarskort',
                    'Giltigt 2 dagar',
                    '180 kr',
                    '2020-12-01',
                    '2021-04-01',
                ),
                new TicketType('3-dagarskort',
                    'Giltigt 3 dagar',
                    '250 kr',
                    '2020-12-01',
                    '2021-04-01',
                ),
                new TicketType('Veckokort',
                    'Giltigt 1 vecka',
                    '300 kr',
                    '2020-12-01',
                    '2021-04-01',
                ),
                new TicketType('Säsongskort',
                    'Giltigt 1 år',
                    '1000 kr',
                    '2020-12-01',
                    '2021-04-01',
                ),
            ],
            selectedTicketTypeIndex: null,
        }),
        computed: {
            ...mapGetters('common', [
                'firstDayOfWeek'
            ]),
        }
    }
</script>

<style scoped>

</style>